module.exports = __webpack_public_path__ + "img/filter-circle-xmark.d14e1039.svg";